module.exports = __webpack_public_path__ + "img/excel.aed56ccb.svg";